import { combineReducers } from 'redux';
import userReducer from "./reducers/userReducer";

const rootReducer = combineReducers({
    user: userReducer,
    // Add more reducers as needed
});

export default rootReducer;
